<template>
  <div class="groups col-5 mt-2">
    <div class="groups-wrap">
      <div><a href="" @click.prevent="$func.showElement('schemas_link')"
              style="border-bottom: 1px dotted #ccc">Группы ссылок: <b>{{ groups.length }}</b></a>
        <button class=" btn btn-sm text-success"
                @click="addGroup()"
                type="button" title="Добавить фразу"><i class="bi bi-plus-square"></i></button>
      </div>

      <div class="list hide" id="schemas_link">
        <div class="head">
          <span style="width: 30px;">Цвет</span>
          <span style="width: 50%;">Название</span>
          <span>Тон</span>
          <div class="buttons ms-auto">

          </div>
        </div>
        <GroupItem
            v-for="(group, index) in groups"
            :key="index"
            :group="group"
            :index="index"
            @save="saveGroup"
            @cancel="cancelEdit"
            @remove="removeGroup"
        />
      </div>
    </div>
  </div>
</template>

<script>
import {GroupApi} from "@/api/groups";
import GroupItem from "@/views/links/includes/GroupItem.vue";

export default {
  name: "LinkColors",
  components: {GroupItem},
  props: {
    project_id: Number,
    country_code: String,
    setGroup: Function
  },
  data() {
    return {
      groups: [],
      defaultColors: [],
      defaultNames: []
    }
  },
  watch: {
    country_code() {
      this.getSchemes()
    },
    groups() {
      this.setGroup(this.groups)
    }
  },
  computed: {},
  mounted() {
    this.getSchemes()
  },
  methods: {
    cancelEdit(group, index) {
      group.edit = false;
      if (!group.id) this.groups.splice(index, 1)
    },
    getNextColor() {
      const exist_color = this.groups.map(c => JSON.stringify(c.color_rgb))
      const next = this.defaultColors.map(x => x).filter(value => !exist_color.includes(JSON.stringify(value)))
      if (next.length) return next[0]
      return null
    },
    getNextName(color) {
      const color_index = this.defaultColors.indexOf(color)
      const defaultName = this.defaultNames[color_index]
      if (defaultName) return defaultName
      return ["", ""]
    },
    addGroup() {
      const color = this.getNextColor();
      const [name, tone] = this.getNextName(color);
      if (color) {
        this.groups.push({id: null, name: name, color_rgb: this.getNextColor(), tone: tone, edit: true});
        this.$func.showElement('schemas_link', true);
      } else {
        this.$notify({
          type: 'error',
          text: "Добавлено максимальное количество групп"
        })
      }
    },
    saveGroup(group, index) {
      group.country_code = this.country_code;
      GroupApi.add_group(this.project_id, group).then(response => this.groups.splice(index, 1, response))
    },
    removeGroup(group, index) {
      GroupApi.remove_group(this.project_id, group).then(r => this.groups.splice(index, 1))
    },
    getSchemes() {
      GroupApi.list(this.project_id, this.country_code).then(r => {
        this.groups = r.groups;
        this.defaultColors = r.default
        this.defaultNames = r.default_names
      });
    }
  }
}
</script>

<style scoped lang="scss">
.list {
  display: flex;
  flex-direction: column;
  gap: 5px;

  .head {
    display: flex;
    width: 100%;
    gap: 10px;

    span {
      font-weight: bold;
      font-size: 14px;
    }
  }

  &.hide {
    display: none;
  }

}

.groups-wrap {
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 0 5px;
}

</style>
